import React from 'react';
import { Accordion, Grid, Flex, TextInput } from '@mantine/core';

interface PointsEditorProps {
    pointArray: any;
    currentPoints: string;
    setHistory: React.Dispatch<React.SetStateAction<string[]>>;
    setCurrentPoints: React.Dispatch<React.SetStateAction<string>>;
    onPointsChange: (newPoints: string) => void;
    t: (key: string) => string;
}

const PointsEditor: React.FC<PointsEditorProps> = ({
    pointArray,
    currentPoints,
    setHistory,
    setCurrentPoints,
    onPointsChange,
    t
}) => {
    const handleInputChange = (index: number, axis: 'x' | 'y', value: string) => {
        const pointsArray = currentPoints.split(' ').map(point => point.split(','));
        pointsArray[index][axis === 'x' ? 0 : 1] = value;

        const updatedPoints = pointsArray.map(point => point.join(',')).join(' ');
        setHistory(prev => [...prev, currentPoints]);
        setCurrentPoints(updatedPoints);
        onPointsChange(updatedPoints);
    };

    return (
        <Accordion variant="contained">
            <Accordion.Item value="points-editor">
                <Accordion.Control>
                    {t('scheme.redactor.panelOptions.setFigure.polilyne.polilyneEditor.editPoints')}
                </Accordion.Control>
                <Accordion.Panel>
                    <Grid>
                        {pointArray.map(([x, y]: any, index: number) => (
                            <Grid.Col span={3} key={`point-${x}-${y}`}>
                                <Flex style={{ border: '1px solid black' }}>
                                    <TextInput
                                        value={x || ''}
                                        onChange={(e) => handleInputChange(index, 'x', e.target.value)}
                                        size="xs"
                                        leftSection={`x${index + 1}:`}
                                        leftSectionWidth={35}
                                        radius={0}
                                    />
                                    <TextInput
                                        value={y || ''}
                                        onChange={(e) => handleInputChange(index, 'y', e.target.value)}
                                        size="xs"
                                        leftSection={`y${index + 1}:`}
                                        leftSectionWidth={35}
                                        radius={0}
                                    />
                                </Flex>
                            </Grid.Col>
                        ))}
                    </Grid>
                </Accordion.Panel>
            </Accordion.Item>
        </Accordion>
    );
};

export default PointsEditor;
